<section class="chatbox" id="bia-comment" [ngClass]="commentBoxClass()">
  <button class="close" (click)="showCommentBox()">
    <i class="pi pi-times"></i>
  </button>
  <section class="chat-window">
    <article class="msg-container msg-self" id="msg-0">
      <div
        class="msg-box p-mb-4 p-pb-2"
        (mouseenter)="handleHover()"
        (mouseleave)="handleBlur()"
        *ngFor="let comment of comments; let i = index"
      >
        <div class="flr">
          <div class="messages">
            <p class="msg p-mt-0">
              {{ comment }}
            </p>
          </div>
        </div>
        <div class="btn-group" *ngIf="showAction">
          <span class="p-buttonset">
            <button
              pButton
              pRipple
              class="p-button-rounded p-button-text p-button-warning"
              icon="pi pi-pencil"
              (click)="editComment(i)"
            ></button>
            <button
              pButton
              pRipple
              class="p-button-rounded p-button-text p-button-warning"
              icon="pi pi-trash"
              (click)="deleteComment(i)"
            ></button>
          </span>
        </div>
      </div>
    </article>
  </section>
  <form class="chat-input" onsubmit="return false;">
    <input
      type="text"
      [(ngModel)]="comment"
      autocomplete="on"
      (ngEnter)="storeComment()"
      placeholder="Type a message"
      name="comment"
    />
    <button (click)="storeComment()">
      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
        <path
          fill="rgba(0,0,0,.38)"
          d="M17,12L12,17V14H8V10H12V7L17,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z"
        />
      </svg>
    </button>
  </form>
</section>
<button
  id="show-comment"
  *ngIf="!commentOpen"
  [ngClass]="chatBtnClass()"
  (click)="showCommentBox()"
>
  <span class="pi pi-comment"></span>
</button>
